// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f4a74a3a","239":"b0618a21","453":"f7fa30d0","667":"5ca08063"}[chunkId] + ".chunk.js";
};